(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3Transfers', {
            templateUrl: 'app/shared/transfers/transfers.component.html',
            controller: TransfersComponent,
            bindings: {
                isClubAdminPage: '<',
                filter: '<',
                transfers: '<',
                managementGroups: '<'
            }
        });

    var noop = angular.noop;

    TransfersComponent.$inject = ['$scope', '$element', 'user', 'Club', 'DataSource', 'clubMembershipTransferStatusType', 'defaultTransferListPageSize', 'alert', 'confirm', 'shared_resources', 'transferLookupPlaceholder'];
    function TransfersComponent($scope, $element, user, Club, DataSource, transferStatus, defaultTransferListPageSize, alert, confirm, resources, transferLookupPlaceholder) {
        var ctrl = this;

        // Properties
        ctrl.filter = null;
        ctrl.transfers = null;
        ctrl.managementGroups = null;
        ctrl.dataSource = null;
        ctrl.statuses = Object.values(transferStatus).filter(statusFilter);
        Object.defineProperty(ctrl, 'isPending', { get: getIsPending })
        ctrl.placeholder = transferLookupPlaceholder;
        ctrl.isNationalLookupAdmin = user.isNationalLookupAdmin;

        // Methods
        ctrl.$onInit = init;
        ctrl.accept = handleTransfer.bind(ctrl, true);  
        ctrl.reject = handleTransfer.bind(ctrl, false);
        ctrl.sort = sort;
        ctrl.getColumnClass = getColumnClass;
        /////////////////////////////////////////

        // Methods
        function init() {
            $element.addClass(ctrl.isClubAdminPage ? 'club-admin' : 'assoc-admin');
            ctrl.dataSource = new DataSource({
                data: ctrl.transfers,
                read: getData,
                filter: ctrl.filter,
                pageSize: defaultTransferListPageSize,
                params: {
                    id: ctrl.transfers.clubId
                }
            });

            $scope.$watch('$ctrl.filter', filterWatchAction, true);
        }
        function handleTransfer(accept, transfer) {
            var clubId = ctrl.clubId,
                confirmMessage = accept ? resources.confirmAcceptTransfer : resources.confirmRejectTransfer,
                errorMessage = accept ? resources.acceptTransferFailed : resources.rejectTransferFailed,
                method = accept ? 'acceptTransfer' : 'rejectTransfer';

            confirm(confirmMessage, transfer.name).then(success, noop);

            function success() {
                Club[method](transfer, success, error, true);

                function success() {
                    ctrl.dataSource.read();
                }
                function error() {
                    alert.error(errorMessage, transfer.name);
                }
            }

        }

        // DataSource
        function sort(field) {
            var dataSource = ctrl.dataSource,
                sort = dataSource.sort;
            dataSource.sort = !sort || sort.field !== field ? { field: field, dir: 'asc' } : sort.dir === 'asc' ? { field: field, dir: 'desc' } : null;
        }
        function getData(options) {
            return Club.getTransferList(options, success, error, true);

            function success(data) {
                ctrl.transfers = data;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.transferListRequestFailed);
            }
        }
        function filterWatchAction(newVal, oldVal) {
            if (oldVal != newVal)
                ctrl.dataSource.page = 1;
        }

        // Helpers
        function statusFilter(status) {
            return status !== transferStatus.TransferError;
        }
        function getIsPending() {
            return ctrl.filter.status === transferStatus.Pending;
        }
        function getColumnClass(field) {
            var sort = ctrl.dataSource.sort;
            return sort && sort.field === field ? sort.dir === 'desc' ? 'sort-link-desc' : 'sort-link-asc' : null;
        }
    }
})();